module.exports = __webpack_public_path__ + "static/media/subGoogle2.49d9ea80.png";